import { render, staticRenderFns } from "./xingzhuang-yanse.vue?vue&type=template&id=34a56a52&scoped=true&"
import script from "./xingzhuang-yanse.vue?vue&type=script&lang=ts&"
export * from "./xingzhuang-yanse.vue?vue&type=script&lang=ts&"
import style0 from "./xingzhuang-yanse.vue?vue&type=style&index=0&id=34a56a52&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a56a52",
  null
  
)

export default component.exports